import { FC } from 'react';
import { Link, ExternalLink } from '@qga/roo-ui/components';
import { SelfServiceAPI } from 'types';
import * as track from 'lib/gaTracking/bookingDetailsPageEvents';

interface GetDirectionsLinksWithTrackingProps {
  booking: SelfServiceAPI.Booking;
}

const GetDirectionsLinksWithTracking: FC<GetDirectionsLinksWithTrackingProps> = ({ booking }: GetDirectionsLinksWithTrackingProps) => {
  return (
    <Link as={ExternalLink} onClick={track.getDirectionsLinkSelected} href={booking.links.googleMaps} target="_blank">
      Get directions
    </Link>
  );
};

export default GetDirectionsLinksWithTracking;
